'use client';

import { FC, useRef } from 'react';
import Link from 'next/link';

import { useIsVisible } from 'hooks/useIsVisible';
import { PRIVACY_POLICY_LINK, TERMS_OF_SERVICE_LINK } from 'app/_data';

export const LandingFooter: FC = () => {
  const footerRef = useRef<HTMLDivElement>(null);
  const isVisibleFooter = useIsVisible(footerRef);

  return (
    <div
      ref={footerRef}
    >
      <div className={`flex items-center justify-center gap-3.5 border-t border-t-[#e6e6f1] duration-1000 transition-all ${isVisibleFooter ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-full'}`}>
        <div className="container">
          <div className="px-5 py-7 flex flex-col gap-9 justify-between font-poppins">
            <div className="flex justify-between font-poppins text-sm text-[#8895aa]">
              <div className="">
                @ {new Date().getFullYear()} KYG. All rights reserved.
              </div>
              <div className="flex gap-7">
                <Link className="hover:text-purple-blue" target="_blank" href={TERMS_OF_SERVICE_LINK}>Terms And Conditions</Link>
                <Link className="hover:text-purple-blue" target="_blank" href={PRIVACY_POLICY_LINK}>Privacy Policy</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
